import { Constant, Headers } from "../apiConstants";

const GetImageAPI = async () => {
    const endpoint = Constant.GET_CAROUSEL_IMG;
    const BaseUrl = Constant.BASE_URL;
    try {
      const response = await fetch(BaseUrl + "/" + endpoint, {
        method: "get",
        headers: Headers,
      });
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error(error);
      throw error;
    }
}

export default GetImageAPI;